import React, { useState, useContext } from 'react';
import { ResultsToggleLayout } from '../components/ResultsToggleLayout';
import { LIST_LAYOUT_STYLE, DEFAULT_LAYOUT_STYLE } from '../utils/constants';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import PropTypes from 'prop-types';

export const ResultsToggleLayoutComposable = ({ experienceType }) => {
  const viewListPods = useConfigService('fs-prop:viewProductCountEnabled');
  const isMAToggleResultsEnabled = useConfigService('fs-prop:isToggleResultsEnabled');
  const defaultLayoutStyle = viewListPods ? LIST_LAYOUT_STYLE : DEFAULT_LAYOUT_STYLE;

  const [layoutStyle, setLayoutStyle] = useState(defaultLayoutStyle);

  const { channel, customer } = useContext(ExperienceContext);
  const isDesktop = channel === 'desktop';
  const isB2B = customer?.type === 'b2b';
  const isMA = experienceType === 'ma';
  const isMAToggleEnabled = isMAToggleResultsEnabled === true || isMAToggleResultsEnabled === 'true';
  const shouldRenderToggle = isDesktop && ((isMA && isMAToggleEnabled) || isB2B);

  const handleLayoutToggle = (style) => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('PLP_LAYOUTSTYLE', style);

      if (window.LIFE_CYCLE_EVENT_BUS) {
        window.LIFE_CYCLE_EVENT_BUS.trigger('PLP_LAYOUTSTYLE.value', { layoutStyle: style });
      }
    }

    setLayoutStyle(style);
  };

  return (shouldRenderToggle
    && <ResultsToggleLayout activeLayout={layoutStyle} toggleActiveLayout={handleLayoutToggle} />);
};

ResultsToggleLayoutComposable.displayName = 'ResultsToggleLayoutComposable';

ResultsToggleLayoutComposable.propTypes = {
  // Valid types:  ma | gm | hdh
  experienceType: PropTypes.string
};

ResultsToggleLayoutComposable.defaultProps = {
  experienceType: null
};
